import { EventAttributes, getDisplayValue } from '@cast/analytics';

const resolvePageHeader = () =>
  getDisplayValue(document.getElementById('page-title'));

const resolveSidebarMenuSelection = () => {
  const mainSidebar = document.getElementById('main-sidebar');
  const selectedItems = mainSidebar?.querySelectorAll(
    '[data-testid^="sidebar-item-"][aria-selected="true"]'
  );
  if (!selectedItems) {
    return;
  }
  const menuTitles: string[] = [];
  for (const menuItem of selectedItems) {
    const title = getDisplayValue(
      menuItem.querySelector('[data-testid="title"]')
    );
    if (title) {
      menuTitles.push(title);
    }
  }
  if (menuTitles.length) {
    return menuTitles.join(' > ');
  }
  return undefined;
};

export const resolveGlobalAttributes = (): EventAttributes => {
  return {
    pageHeader: resolvePageHeader(),
    sidebarMenuItem: resolveSidebarMenuSelection(),
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
  };
};
